import { State, Action, Selector, StateContext } from '@ngxs/store';
import {
  ApiCustomerSearch,
  ApiCustomerSearchSuccess,
  ApiCustomerSearchError,
  ResetCustomerSearchAction,
} from './customer-search.actions';
import { SearchResult } from '@shared/models/search-result.model';
import { tap, catchError } from 'rxjs/operators';
import { NotificationService } from '@core/services/notification.service';
import { Injectable, inject } from '@angular/core';
import { CustomerService } from '@sales/modules/details/services/customer.service';

export interface CustomerSearchStateModel {
  searchResults: SearchResult[];
  autoSuggestions: SearchResult[];
  searchQuery: string;
  birthDateFilter: string;
  pageNumber: number;
  isLoadingSearchResults: boolean;
  searchResultsCount: number;
  hasMoreSearchResults: boolean;
  blockQuickSearch: boolean;
  msisdn: string;
  isMsisdnSearch: boolean;
}

const initialCustomerSearch = {
  searchResults: [],
  autoSuggestions: [],
  searchQuery: '',
  birthDateFilter: '',
  pageNumber: 1,
  isLoadingSearchResults: false,
  searchResultsCount: 0,
  hasMoreSearchResults: false,
  blockQuickSearch: false,
  msisdn: '',
  isMsisdnSearch: false,
};

@State<CustomerSearchStateModel>({
  name: 'customerSearch',
  defaults: initialCustomerSearch,
})
@Injectable()
export class CustomerSearchState {
  private customerService = inject(CustomerService);
  private notificationService = inject(NotificationService);

  @Selector()
  public static getState(state: CustomerSearchStateModel) {
    return state;
  }

  @Selector()
  static privateCustomers(state: CustomerSearchStateModel) {
    return { ...state, searchResults: state.searchResults.filter(value => value.isPrivateCustomer) };
  }

  @Action(ApiCustomerSearch)
  apiSearch({ dispatch, patchState }: StateContext<CustomerSearchStateModel>, action: ApiCustomerSearch) {
    patchState({ isLoadingSearchResults: true });
    return this.customerService.customerSearch(action.query).pipe(
      tap(response => dispatch(new ApiCustomerSearchSuccess(response))),
      catchError(() => dispatch(new ApiCustomerSearchError('Error in search')))
    );
  }

  @Action(ApiCustomerSearchSuccess)
  public customerAdd({ patchState }: StateContext<CustomerSearchStateModel>, action: ApiCustomerSearchSuccess) {
    patchState({
      searchResults: action.searchResponse.searchResults,
      searchResultsCount: action.searchResponse.totalNumberOfSearchResults,
      isLoadingSearchResults: false,
    });
  }

  @Action(ApiCustomerSearchError)
  public searchError({ patchState }: StateContext<CustomerSearchStateModel>, action: ApiCustomerSearchError) {
    this.notificationService.error(action.error);
    patchState({ isLoadingSearchResults: false });
  }

  @Action(ResetCustomerSearchAction)
  public resetCustomerSearch({ setState }: StateContext<CustomerSearchStateModel>) {
    setState(initialCustomerSearch);
  }
}
